import { Instance } from 'mobx-state-tree';
import { ProjectStopsSchedulingDtoModelBase } from './ProjectStopsSchedulingDtoModel.base';

/* The TypeScript type of an instance of ProjectStopsSchedulingDtoModel */
export interface ProjectStopsSchedulingDtoModelType extends Instance<typeof ProjectStopsSchedulingDtoModel.Type> {}

/* A graphql query fragment builders for ProjectStopsSchedulingDtoModel */
export { selectFromProjectStopsSchedulingDto, projectStopsSchedulingDtoModelPrimitives, ProjectStopsSchedulingDtoModelSelector } from './ProjectStopsSchedulingDtoModel.base';

/**
 * ProjectStopsSchedulingDtoModel
 *
 * Scheduling stops
 */
export const ProjectStopsSchedulingDtoModel = ProjectStopsSchedulingDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
